import { useLayoutEffect as o } from "react";
const e = globalThis?.document ? o : () => {
};
export {
  e as useLayoutEffect
};
//# sourceMappingURL=index.es430.js.map
